<!--
 * Description  :
 * Date         :2021-12-16 14:26:21
 * LastEditors  :chenjia
 * LastEditTime :2024-06-20 16:27:41
 * FilePath     :\aomei-pay\src\components\HeaderFooter\Header.vue
-->
<template>
  <header class="header">
    <nav class="f-cb">
      <div class="container">
        <div class="logo-box">
          <a href="/" class="logo">
            <img src="@/assets/logo-m.png" alt="" />
            <div class="txt">
              <h5>傲梅备份</h5>
              <!-- <p>AomeiBackup</p> -->
            </div>
          </a>
          <div class="nav-tg" :class="isOpenNav" @click="handleOpenNav">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <ul class="header-nav" :class="isOpenNav">
          <li class="nav-it"><a href="/">首页</a></li>
          <li class="nav-it"><a href="/purchase.html">商店</a></li>
          <li class="nav-it hasdropdown" @mouseover="onDPover($event)" @mouseout="onDPOut($event)">
            <a href="javascript:;">个人备份</a>
            <div class="dropdown dropdown-2">
              <ol>
                <li>
                  <a href="/easy-backup-personal.html"
                    >傲梅轻松备份<i class="ic-hd hot">免费</i><br />
                    <span>简单易用的个人备份软件，可备份、还原、同步、迁移等</span>
                  </a>
                </li>
                <li>
                  <a href="/one-click-recovery.html">
                    傲梅一键还原<i class="ic-hd hot">免费</i><br />
                    <span>一键创建恢复分区，系统问题可及时一键还原</span>
                  </a>
                </li>
              </ol>
            </div>
          </li>
          <li class="nav-it hasdropdown" @mouseover="onDPover($event)" @mouseout="onDPOut($event)">
            <a href="javascript:;">企业备份</a>
            <div class="dropdown dropdown-2">
              <ol>
                <li>
                  <a href="/easy-backup-enterprise.html"
                    >傲梅企业备份标准版
                    <br />
                    <span>中小企业的重要数据备份、同步、整机备份等</span>
                  </a>
                </li>
                <li>
                  <a href="/centralized-backup.html"
                    >傲梅企业备份网络版
                    <br />
                    <span>中小企业集中管理重要员工数据备份，统一管理，防止数据丢失</span>
                  </a>
                </li>
                <li>
                  <a href="/edition-comparison.html"
                    >企业备份版本对比<br /><span
                      >详细对比标准版、网络版、旗舰版功能，帮助您选择适合的版本</span
                    ></a
                  >
                </li>
                <li>
                  <a href="/cyber-backup.html"
                    >傲梅企业备份旗舰版
                    <br />
                    <span>中小企业集中备份管理电脑数据、虚拟机、数据库等</span></a
                  >
                </li>
                <li>
                  <a href="/solution/index.html"
                    >备份解决方案
                    <br />
                    <span>查看您所在行业的企业是如何备份数据的，便于您参考、借鉴</span>
                  </a>
                </li>
              </ol>
            </div>
          </li>
          <li class="nav-it hasdropdown" @mouseover="onDPover($event)" @mouseout="onDPOut($event)">
            <a href="javascript:;">支持中心</a>
            <div class="dropdown">
              <ol>
                <li><a href="/user-stories/">成功用户案例</a></li>
                <li><a href="/help/">产品使用教程</a></li>
                <li><a href="/easybackup-tutorials/">个人备份指南</a></li>
                <li><a href="/enterprise-backup/">企业备份指南</a></li>
                <li><a href="/help/purchase-faq.html">售前疑问解答</a></li>
                <li><a href="/service.html">售前售后支持</a></li>
              </ol>
            </div>
          </li>
          <li class="nav-it"><a href="/download.html">免费下载</a></li>
          <li class="nav-it"><a href="/partner.html">合作伙伴</a></li>
          <li class="nav-it"><a href="/about.html">关于我们</a></li>
          <li class="nav-it nav-it-button">
            <a href="https://vip.abackup.com/" class="login-a" target="_blank">{{
              isAuth ? "个人中心" : "登录"
            }}</a>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
// import { defineComponent } from '@vue/composition-api'

export default {
  name: "AbHeader",
  data() {
    return {
      isOpenNav: "",
      isAuth: false
    };
  },
  computed: {},
  methods: {
    handleOpenNav() {
      this.isOpenNav === "" ? (this.isOpenNav = "open") : (this.isOpenNav = "");
    },
    hasClass(elements, cName) {
      return !!elements.className.match(new RegExp("(\\s|^)" + cName + "(\\s|$)"));
    },
    addClass(elements, cName) {
      if (!this.hasClass(elements, cName)) {
        elements.className += " " + cName;
      }
    },
    removeClass(elements, cName) {
      if (this.hasClass(elements, cName)) {
        elements.className = elements.className.replace(
          new RegExp("(\\s|^)" + cName + "(\\s|$)"),
          " "
        );
      }
    },
    onDPover(event) {
      let $this = event.currentTarget;
      // console.log($this)
      this.addClass($this, "open");
    },
    onDPOut(event) {
      let $this = event.currentTarget;
      this.removeClass($this, "open");
    },
    getCookie: function(name) {
      var strcookie = document.cookie;
      var arrcookie = strcookie.split("; ");
      for (var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split("=");
        if (arr[0] == name) {
          return arr[1];
        }
      }
      return "";
    },
    login() {
      this.getCookie("auth") && (this.isAuth = true);
    }
  },
  created() {
    this.login();
  }
};
</script>
<style lang="less" scoped>
.header {
  // box-shadow: 1px 1px 4px rgba(0, 0, 0, .1);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 200;
  width: 100%;
  z-index: 2000;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.5;
  font-size: 16px;
  background-color: #203491;
  p,
  a {
    color: rgba(255, 255, 255, 0.7);
  }

  h5 {
    color: #fff;
    font-size: 20px;
  }

  &-nav {
    float: right;
    font-size: 16px;

    .nav-it {
      margin-left: 40px;
      float: left;
      position: relative;

      &::after {
        content: "";
        display: block;
        width: 50px;
        height: 4px;
        background: #fff;
        border-radius: 2px;
        position: absolute;
        bottom: 0px;
        left: calc(50% - 25px);
        opacity: 0;
      }

      & > a {
        padding: 28px 0;
        display: inline-block;
      }

      &:first-child {
        margin-left: 0;
      }
      &.nav-it-button {
        &::after {
          display: none;
        }
      }
      .login-a {
        height: 36px;
        line-height: 26px;
        padding: 2px 15px !important;
        border: 2px solid rgba(255, 255, 255, 0.7);
        border-radius: 4px;
        margin: 21px 0;
        transition: margin-top 0.5s;
        &:hover {
          color: #fff;
          border-color: #fff;
          &::before {
            border-color: #fff;
          }
        }
      }
    }
  }

  .hasdropdown {
    position: relative;

    &.nav-it::after {
      width: 0;
      height: 0;
      border-bottom: 5px solid #fff;
      border-right: 7px solid transparent;
      border-left: 7px solid transparent;
      left: calc(50% - 19px);
      bottom: 0;
      background-color: transparent;
    }

    & > a::after {
      content: "";
      display: inline-block;
      border-top: 6px solid rgba(255, 255, 255, 0.7);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      margin-left: 10px;
      position: relative;
      top: -1px;
    }

    &.nav-it:nth-child(6) .dropdown {
      left: -90px;
    }

    .dropdown {
      position: absolute;
      top: 80px;
      left: -80px;
      min-width: 220px;
      /* display: none; */
      max-height: 0;
      overflow: hidden;
      background-color: #fff;
      -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
      opacity: 1;
      border-radius: 0 0 10px 10px;

      a {
        color: #175dc0;
        font-size: 17px;
        font-weight: normal;
      }

      ol {
        padding: 20px 0 15px;
      }

      li {
        background-color: #fff;
        display: block;
        position: relative;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        padding: 0;
        text-align: center;
        &:not(:last-child) {
          margin-bottom: 10px;
        }
        a {
          position: relative;
        }
        a::before {
          position: absolute;
          top: 5px;
          left: -20px;
          display: inline-block;
          content: "";
          width: 0;
          height: 0;
          border-top: 5px solid transparent;
          border-left: 10px solid rgb(82, 77, 77);
          border-bottom: 5px solid transparent;
        }
        &::after {
          content: "";
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: #e9f3ff;
          z-index: -1;
          -webkit-transition: all 0.5s ease;
          -moz-transition: all 0.5s ease;
          transition: all 0.5s ease;
          -webkit-transform: translateX(-220px);
          -moz-transform: translateX(-220px);
          -ms-transform: translateX(-220px);
          transform: translateX(-220px);
        }

        &:hover {
          background-color: transparent;
          color: #0084ff;
          border-color: #008fff;
          z-index: 0;

          &::after {
            -webkit-transform: translateX(0px);
            -moz-transform: translateX(0px);
            -ms-transform: translateX(0px);
            transform: translateX(0px);
          }

          a {
            color: #0087ff;
          }
        }
      }
    }
    .dropdown-2 {
      li {
        min-width: 450px;
        min-height: 76px;
        text-align: left;
        padding: 6px 0 0px 40px;
        a {
          color: #175dc0;
          font-size: 17px;
          font-weight: bold;
        }
        span {
          font-size: 14px;
          color: #666;
          font-weight: normal;
        }
        .ic-hd {
          display: inline-block;
          height: 21px;
          /* width: 37px; */
          padding: 0 8px 0 7px;
          font-size: 14px;
          transform: scale(0.75);
          color: #fff;
          text-align: center;
          line-height: 24px;
          border-radius: 4px;
          position: relative;
          margin-left: 5px;
          font-style: normal;
        }

        .ic-hd::before {
          content: "";
          border-top: 6px solid transparent;
          border-bottom: 6px solid transparent;
          border-right: 6px solid transparent;
          position: absolute;
          top: 5px;
          left: -5px;
        }

        .ic-hd.hot {
          background-color: #f86433;
          background: linear-gradient(213deg, #f48f70 30%, #f94f15);
        }

        .ic-hd.hot::before {
          border-right-color: #f86433;
        }
      }
    }
  }

  .nav-tg {
    display: none;
  }

  //hover
  .nav-it:hover::after {
    opacity: 1;
  }
  // .hasdropdown:hover,
  .open {
    &.nav-it {
      &::after {
        opacity: 1;
      }

      & > a {
        color: #fff;
      }
    }

    &.hasdropdown {
      & > a::after {
        border-top-color: #fff;
      }

      .dropdown {
        max-height: 800px;
        opacity: 1;
        transition: max-height 1s linear;
      }
    }
  }
}

.scrolling {
  .header {
    background: #203491;
    .hasdropdown .dropdown {
      top: 70px;
    }
  }
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .header .hasdropdown .dropdown {
    display: none;
  }

  .header .hasdropdown.open .dropdown {
    display: block;
  }
}

@supports (-ms-ime-align: auto) {
  .header .hasdropdown .dropdown {
    display: none;
  }

  .header .hasdropdown.open .dropdown {
    display: block;
  }
}

@media (min-width: 1024px) {
  .logo-box,
  .header-nav .nav-it > a {
    transition: padding-top 0.5s;
  }

  .scrolling {
    .header {
      background: #203491;

      .logo-box {
        padding: 10px 0;
      }

      .header-nav .nav-it > a {
        padding: 23px 0;
      }
      .header-nav .nav-it-button .login-a {
        margin: 18px 0;
      }
    }
  }
}

@media all and (max-width: 1023px) {
  body {
    padding-top: 100px;
  }
  .header {
    background: #203491;

    .logo-box {
      width: 100%;
      float: none;
      padding: 25px 0;

      .nav-tg {
        display: block;
        width: 30px;
        float: right;
        position: relative;
        -webkit-transition: all 0.65s;
        -moz-transition: all 0.65s;
        transition: all 0.65s;
        margin-top: 10px;

        span {
          display: block;
          height: 4px;
          background-color: #fff;
          margin-bottom: 8px;
        }
      }
    }

    .header-nav {
      float: none;
      max-height: 400px;
      display: none;
      overflow-x: hidden;
      transition: all 0.5s linear;

      .nav-it {
        width: 100%;
        margin-left: 0;
        float: none;
        border-top: 1px solid rgba(238, 238, 238, 0.5);
        &::after {
          display: none !important;
        }

        & > a {
          padding: 8px 0;
        }
      }
    }

    .hasdropdown {
      .dropdown {
        opacity: 1;
        position: static;
        width: 100%;
        border-radius: 0;

        a {
          display: block;
        }
        li {
          text-align: left;
          padding-left: 40px;
          min-height: auto;
          height: auto;
          width: auto;
          min-width: auto;
          a::before {
            top: 10px;
          }
        }
      }
      .dropdown-2 {
        min-width: auto;
      }
    }

    .open {
      &.nav-tg span {
        transition: transform 0.65s;
        margin: 0;
        position: absolute;
        width: 100%;

        &:first-child {
          top: 9px;
          transform-origin: center;
          transform: rotate(45deg);
        }

        &:nth-child(2) {
          bottom: -17px;
          transform-origin: center;
          transform: rotate(-45deg);
        }

        &:last-child {
          display: none;
        }
      }

      &.header-nav {
        // max-height: 800px;
        // display: block;
      }
    }
    .open.header-nav {
      display: block;
    }
  }
}
@media (max-width: 1023px) {
  body {
    padding-top: 52px !important;
  }
  .header {
    .logo-box {
      padding: 10px;

      img {
        width: 40px;
      }

      .txt h5 {
        font-size: 16px;
      }

      .nav-tg {
        margin-top: 6px;
        width: 22px;

        span {
          height: 2px;
          margin-bottom: 6px;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
</style>
